import { DSDisciplines } from '../../../cimsPage/instances/ds'
import { CreateViewEditSoftRemoveRestore } from '../../common'

const disciplines = CreateViewEditSoftRemoveRestore({
  page: DSDisciplines,
  object: 'Discipline',
  create: '080ADCFB-E1EF-4F05-9FEF-AD42DA79F0D4',
  view: 'DF7D39A6-193D-4584-A1A2-98F9BC4ED578',
  edit: 'D4D8840F-FA95-4A48-B6E8-CB4726E5A4A4',
  removeRestore: '57237795-206B-4AC3-85E2-7F4B37C5B6C2',
})

export const CreateDesignSubmittalDiscipline = disciplines.Create
export const ViewDesignSubmittalDiscipline = disciplines.View
export const EditDesignSubmittalDiscipline = disciplines.Edit
export const RemoveRestoreDesignSubmittalDiscipline = disciplines.RemoveRestore

export type DSDisciplinePermission =
  | typeof CreateDesignSubmittalDiscipline
  | typeof ViewDesignSubmittalDiscipline
  | typeof EditDesignSubmittalDiscipline
  | typeof RemoveRestoreDesignSubmittalDiscipline
